<script lang="ts" setup>
	const emits = defineEmits<{
		(arg: 'remove'): void
	}>()
</script>

<template>
	<div
		class="mx-auto flex min-h-[200px] w-full flex-col items-center rounded-lg border border-gray-300 bg-gray-100 px-5 py-10"
	>
		<div class="flex w-full justify-end">
			<button type="button" @click="emits('remove')">
				<lazy-tools-icon dir="other" icon="trash" />
			</button>
		</div>
		<div class="mt-3">
			<slot />
		</div>
	</div>
</template>
